import { Component, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute, Router } from '@angular/router'
import { NotificationDialogComponent } from '../../customer-area/home-page/notification-dialog/notification-dialog.component'
import { NotificationService as NotifService } from '../../customer-area/home-page/shared/notification.service'
import { AuthenticationService } from '../shared/authentication/authentication.service'
import { LoginForm } from './login-form'
import { LoginRequest } from './login-request'
import { MatSnackBar } from '@angular/material/snack-bar'
import { NotificationService } from '../../notification/shared/notification.service'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './../shared/user.scss',
    './login.component.scss'
  ],
})
export class LoginComponent implements OnInit {

  form: LoginForm

  private redirectURI: string
  private queryParams
  showPassword = true

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private notifService: NotifService,
    private dialog: MatDialog,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.form = new LoginForm()
    this.route.queryParams.subscribe(params => {
      this.redirectURI = params.redirectURI
      if (this.redirectURI) {
        this.sortParams()
      }
    })
  }

  private prepareLogin(): LoginRequest {
    return this.form.buildUser()
  }

  private resetForm() {
    this.form.reset()
  }

  private loginSuccess() {
    this.notificationService.close()
    if (this.redirectURI) {
      this.router.navigate([this.redirectURI.split('?')[0]], { queryParams: this.queryParams }).then(() => {
        this.showNotif()
      })
    } else {
      this.router.navigate(['/']).then(() => {
        this.showNotif()
      })
    }
  }

  private loginFailed(error: any) {
    this.authenticationService.logout()
    switch (error.status) {
      case 401: {
        this.form.setErrors({ "unauthorized": true })
      }
      //maybe others
    }

  }

  public submit() {
    if (this.form.valid) {
      this.authenticationService.login(this.prepareLogin()).subscribe(
        user => this.loginSuccess(),
        error => this.loginFailed(error))
    } else {
    }
  }

  sortParams() {
    let queryParams = this.redirectURI.split('?')[1]
    let params = queryParams.split('&')
    let pair = null
    let data = {}
    params.forEach((d) => {
      pair = d.split('=')
      data[`${pair[0]}`] = pair[1]
    })
    this.queryParams = data
  }

  showNotif() {
    this.notifService.getNotif().subscribe(data => {
      if (data) {
        let notifStatus = JSON.parse(localStorage.getItem('notification'))
        if (!notifStatus || notifStatus.id != data.id) {
          notifStatus = localStorage.setItem('notification', JSON.stringify({ id: data.id, enabled: true }))
          this.dialog.open(NotificationDialogComponent, {
            data: { notif: data }
          })
        } else if (notifStatus && notifStatus.enabled) {
          this.dialog.open(NotificationDialogComponent, {
            data: { notif: data }
          })
        }
      }
    })
  }

  toggleVisibility() {
    this.showPassword = !this.showPassword
  }
}
